import { Injectable } from '@angular/core';

import { MatIconRegistry } from '@angular/material/icon';

import { DomSanitizer } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class IconService {
  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {}

  registerIcons(): void {
    const icons: Record<string, string> = {
      'info-conversation': 'assets/icons/info-conversation.svg',
      'success-circle': 'assets/icons/success-circle.svg',
      'warning-circle': 'assets/icons/warning-circle.svg',
      'upload-file': 'assets/icons/upload-file.svg',
      'arrow-left': 'assets/icons/arrow-left.svg',
      'arrow-right': 'assets/icons/arrow-right.svg',
      stripe: 'assets/icons/stripe.svg',
      settings: 'assets/icons/settings.svg',
    };

    Object.entries(icons).forEach(([name, path]) => {
      this.matIconRegistry.addSvgIcon(name, this.domSanitizer.bypassSecurityTrustResourceUrl(path));
    });
  }
}
